<template>
    <div class="input-wrapper text-[14px]">
        <div class="flex justify-between md:mb-3 items-center relative">
            <div v-if="label" class="basis-2/5 pr-2">
                <label class="label relative" v-if="label" :class="[(!content && !global.loader.isLoading) ? 'opacity-30' : '']">
                    <span class="inline-block relative">
                        <span :class="[global.loader.isLoading ? 'invisible' : '']">
                            {{ label }}
                        </span>
                        <div class="absolute top-0 translate-y-1/2 w-full max-w-[220px] animate-pulse h-2 bg-deep-blue/20 rounded-full" v-if="global.loader.isLoading"></div>
                    </span>
                </label>
            </div>
            <input
                :disabled="disabled"
                v-model="content"
                :type="type"
                :class="[classNames ? classNames : '']"
                class="border border-black/20 bg-transparent px-3 py-2 pl-8 font-semibold placeholder:text-black"
                :placeholder="placeholder"
            />
            <img :src="global.app.url + 'images/icons/search.svg'" class="absolute left-[8px] w-[18px] cursor-pointer" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "SearchComponent",
    props: {
        name: { type: String, default: "" }, // "Name" prop for naming the input
        value: { default: "" }, // "Value" prop for setting an initial value for the input
        label: { type: String, default: "" }, // Label used for the input
        type: { type: String, default: "text" }, // The type of input field to use
        disabled: { type: Boolean, default: false }, // Used to set the input to a "disabled" state
        classNames: { type: String, default: "" }, // Using custom component variable due to reserved naming issues of "class"
        icon: { type: String, default: "" },
        placeholder: { type: String, default: "" },
    },
    computed: {
        ...mapGetters(["global"]),
    },
    data: function () {
        return {
            content: this.value,
        };
    },
    methods: {},
    watch: {
        value(value) {
            this.content = value;
        },
        content(value) {
            this.content = value;
            this.$emit("input", this.content);
            this.$emit("change", this.content);
        },
    },
    unmounted(){
        this.content = "";
    }
};
</script>
